import type { FC } from 'react';
import { Navigate } from 'react-router-dom';

import { ROUTE } from './enums';
import { AppByAuthRouteI } from './types';

export const PrivateRoute: FC<AppByAuthRouteI> = ({ element, isLoggedIn }) => {
  return isLoggedIn ? element : <Navigate to={ROUTE.SignIn} replace />;
};
